import React from 'react'
import Adsense from 'react-adsense';
import './anuncio.css'

const Anuncio = () => {
  return <div className="anuncio-anuncio">
    <Adsense.Google
      client="ca-pub-9329056724272635"
      slot="2914117228"
      style={{ display: 'block', width: "100%" , height: "100%" }}
      layout="in-article"
      format="fluid"
    />
  </div>
}

export default Anuncio